module.exports = __webpack_public_path__ + "img/poster (11).cff378d7.jpg";